<template>
  <div class="kk-carousel">
    <div v-for="(text, index) in texts" :key="index">
      <div v-if="currentIndex == index" class="kk-carousel_text fade">
        {{ text }}
      </div>
    </div>
    <div class="kk-carousel_delimiters">
      <div
        v-for="(text, index) in texts"
        :key="index"
        class="kk-carousel_delimiters-delimiter"
        :class="{
          'kk-carousel_delimiters-delimiter_active': currentIndex === index,
        }"
        @click="selectSlide(index)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["message"],
  data() {
    return {
      texts: this.message,
      currentIndex: 0,
      intervalId: null,
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    locale() {
      this.texts = this.message;
    },
  },
  mounted() {
    this.startSliding();
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  methods: {
    startSliding() {
      this.intervalId = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.texts.length;
      }, 10000);
    },
    selectSlide(index) {
      this.currentIndex = index;
      clearInterval(this.intervalId);
      this.startSliding();
    },
  },
};
</script>
<style lang="less">
@import "../../assets/styles/variables.less";

.kk-carousel {
  width: 100%;
  &_text {
    font-size: 1rem;
    color: #92a3ab;
    margin: 2rem 0;
  }
  &_delimiters {
    display: flex;
    gap: 1rem;
    padding-left: 2rem;
    &-delimiter {
      width: 0.7rem;
      height: 0.7rem;
      background-color: @kk-color-light-gold;
      border-radius: 50%;
      transition: background-color 1s ease;
      &:hover,
      &_active {
        cursor: pointer;
        background-color: @kk-color-gold;
      }
    }
  }
}
/* Fading animation */
.fade {
  animation-name: fade;
  animation-duration: 1.5s;
}

@keyframes fade {
  from {
    opacity: 0.4;
  }
  to {
    opacity: 1;
  }
}
</style>
